export default __webpack_public_path__ + "static/broschuere-vivawest-72c0e0a5a35c11673172b8d7fbf7171a.jpg";